/*
 * Purpose: User-facing support topics SSOT — Help UI + docs/support map
 * Last modified: 2026-06-28 | Agent
 * Completeness: 98
 */
import { APP_ROUTES } from '@/lib/appRoutes';
import { PRODUCT_TERMS } from '@/lib/productTerms';

export interface SupportTopic {
  id: string;
  title: string;
  summary: string;
  docPath: string;
  appHref?: string;
}

/** User-facing support only — no dev/deploy/API internals */
export const USER_SUPPORT_TOPICS: SupportTopic[] = [
  {
    id: 'getting-started',
    title: 'Getting started',
    summary: `What ${PRODUCT_TERMS.productBrand} is, Mission vs Flow, and your first outcome.`,
    docPath: '/docs/support/01-getting-started.md',
    appHref: APP_ROUTES.home,
  },
  {
    id: 'compose',
    title: 'Describe & compose',
    summary: 'Home autopilot, final plan panel, dry run, and Run live.',
    docPath: '/docs/support/02-compose-and-autopilot.md',
    appHref: APP_ROUTES.compose,
  },
  {
    id: 'migrate',
    title: 'Migrate from Zapier, Make, or n8n',
    summary:
      'Replace Zaps, Make scenarios, or n8n workflows with outcome-driven AutoBlock Flows — no vendor recipe lock-in.',
    docPath: '/docs/support/02-compose-and-autopilot.md',
    appHref: APP_ROUTES.compose,
  },
  {
    id: 'dashboard',
    title: 'Dashboard & live runs',
    summary: 'Command center, stop running flows, ready vs building survey.',
    docPath: '/docs/support/03-dashboard-live-runs.md',
    appHref: APP_ROUTES.dashboard,
  },
  {
    id: 'flows-mission',
    title: 'My flows & Mission',
    summary: 'Flow library, map editor, Check, Start, and Stop.',
    docPath: '/docs/support/04-flows-and-mission.md',
    appHref: APP_ROUTES.missionMap,
  },
  {
    id: 'connect',
    title: 'Connect & onboarding',
    summary: `${PRODUCT_TERMS.onboardingWizard}, vault, and connector library.`,
    docPath: '/docs/support/05-connect-vault-setup.md',
    appHref: APP_ROUTES.connectSetup,
  },
  {
    id: 'credentials',
    title: 'Credentials & Flow Setup',
    summary: `${PRODUCT_TERMS.autoBlockFlowSetup} — unlock vault, keys, Gmail, LinkedIn.`,
    docPath: '/docs/support/06-credentials-flow-setup.md',
    appHref: APP_ROUTES.connectSecrets,
  },
  {
    id: 'sign-in',
    title: 'Sign in & workspaces',
    summary: 'Passwordless sign-in, tenant picker, lost key recovery.',
    docPath: '/docs/support/07-sign-in-workspaces.md',
    appHref: APP_ROUTES.authSignIn,
  },
  {
    id: 'dry-run-live',
    title: 'Dry run vs live',
    summary: 'When simulation is enough and when connections are required.',
    docPath: '/docs/support/08-dry-run-vs-live.md',
    appHref: APP_ROUTES.compose,
  },
  {
    id: 'troubleshooting',
    title: 'Troubleshooting',
    summary: 'Symptom → fix tables for vault, Gmail, compose, and runs.',
    docPath: '/docs/support/09-troubleshooting.md',
  },
  {
    id: 'keyboard',
    title: 'Keyboard shortcuts',
    summary: 'Mission map and command palette shortcuts.',
    docPath: '/docs/support/10-keyboard-shortcuts.md',
    appHref: APP_ROUTES.missionMap,
  },
  {
    id: 'about',
    title: 'About & version',
    summary: 'Release version, proprietary notice, Teknoled-G.',
    docPath: '/docs/support/11-about-version-legal.md',
    appHref: `${APP_ROUTES.help}?tab=about`,
  },
];

export const USER_SUPPORT_HUB = '/docs/support/README.md';
